import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface GameState {
  loadingGame: boolean
  loadingProgress: number
  currentScene: string | null
  network: any | null
}

const initialState: GameState = {
  loadingGame: false,
  loadingProgress: 0,
  currentScene: null,
  network: null,
}

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setLoadingGame: (state, action: PayloadAction<boolean>) => {
      state.loadingGame = action.payload
      if (!action.payload) {
        state.loadingProgress = 0
      }
    },
    setLoadingProgress: (state, action: PayloadAction<number>) => {
      state.loadingProgress = Math.min(100, Math.max(0, action.payload))
    },
    setCurrentScene: (state, action: PayloadAction<string>) => {
      state.currentScene = action.payload
    },
    setNetwork: (state, action: PayloadAction<any>) => {
      state.network = action.payload
    },
  },
})

export const { setLoadingGame, setLoadingProgress, setCurrentScene, setNetwork } = gameSlice.actions
export default gameSlice.reducer
